/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
/* eslint-disable max-len */
import { ButtonProps } from './Button';

export const themeClasses = {
    default: {
        white: 'bg-white text-slate-700 border',
        slate: 'bg-transparent border text-slate-700 bg-white border-slate-200 disabled:opacity-50',
        purple: 'bg-purple-700 text-white border border-purple-700 disabled:bg-slate-100 disabled:text-slate-400 disabled:border-slate-100',
    },
    hollow: {
        white: 'bg-white text-slate-700 border',
        slate: 'bg-transparent border text-slate-700 bg-white border-slate-200 disabled:opacity-50',
        purple: 'bg-transparent text-purple-700 border border-purple-700 disabled:bg-slate-100 disabled:text-slate-400 disabled:border-slate-400',
    },
};

export const themes = (
    theme: ButtonProps['theme'] = 'default',
    color: ButtonProps['color'],
    size: ButtonProps['size'],
) => {
    let sizeClass = '';
    switch (size) {
        case 'small':
            sizeClass = 'font-medium px-3 py-1 text-body';
            break;
        case 'large':
            sizeClass = 'text-lg leading-7 px-6';
            break;
        default:
            sizeClass = 'text-base';
            break;
    }

    return { spacing: sizeClass, themeClass: themeClasses[theme][color] };
};
